import _get from "lodash/get";
import _size from "lodash/size";
import { RootState } from "../../../../models";
import { UpdatePortingDateSubscriptionSimplified } from "../../../../models/state";

export const getUpdatePortingDate = (state: RootState) => _get(state, "updatePortingDate");
export const getSubscriptions = (state: RootState) => getUpdatePortingDate(state)?.subscriptions || [];
export const getHolidays = (state: RootState) => getUpdatePortingDate(state)?.holidays || {};
export const getCreationDate = (state: RootState) => getUpdatePortingDate(state)?.creationDate;
export const isAllNewDatesEqual = (state: RootState) => {
    const subscriptions = getSubscriptions(state);

    if (_size(subscriptions) === 0) {
        return false;
    }

    const referenceDateString = _get(subscriptions[0], "portingInfo.newDate", null);
    if (!referenceDateString) {
        return false;
    }

    return subscriptions.every((sub) => {
        const newDateString = _get(sub, "portingInfo.newDate", 0);
        return new Date(referenceDateString).getTime() === new Date(newDateString).getTime();
    });
};
export const isAtLeastOnePortInUpdated = (state: RootState) => {
    const subscriptions = getSubscriptions(state);

    if (_size(subscriptions) === 0) {
        return false;
    }

    return subscriptions.some((sub) => {
        const newDateString = _get(sub, "portingInfo.newDate", 0);
        const estimatedDateString = _get(sub, "portingInfo.estimatedDate", 0);
        return newDateString && new Date(estimatedDateString).getTime() !== new Date(newDateString).getTime();
    });
};
export const getUpdatedPortingDates = (state: RootState): UpdatePortingDateSubscriptionSimplified[] => {
    const subscriptions = getSubscriptions(state);
    return subscriptions
        .filter((sub) => !!_get(sub, "portingInfo.newDate", null))
        .map((sub) => ({
            guid: sub.guid,
            phoneNumber: sub.phoneNumber,
            date: _get(sub, "portingInfo.newDate"),
        }));
};
export const isAtLeastOnePortInUpdateAvailable = (state: RootState) => {
    return getSubscriptions(state).some((sub) => sub.isAllowedToUpdate);
};
export const getUpdatedRemote = (state: RootState) => getUpdatePortingDate(state)?.updated;
export const hasPerformedRemoteUpdate = (state: RootState) => !!getUpdatedRemote(state)?.isPerformed;
export const getSuccessfullyUpdatedDates = (state: RootState) => getUpdatedRemote(state)?.success || [];
export const getFailedUpdatedDates = (state: RootState) => getUpdatedRemote(state)?.failed || [];
export const getInvalidUpdatedDates = (state: RootState) => getUpdatedRemote(state)?.invalid || [];
